module.exports = __webpack_public_path__ + "media/images/gba/2019/v2/isologotipo_b_blanco-9c6e4412f2f576cef91a4aa7531b153f.svg";